import { Component, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { environment } from '@env/environment';
import { getHomeRoute } from '@app/core/permissions';
import { UserFacade } from '@app/store/user';
import { build } from '../../../build';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    imports: [TranslatePipe, RouterModule],
})
export class FooterComponent {
    private readonly userFacade = inject(UserFacade);

    readonly currentYear: number = new Date().getFullYear();
    readonly buildTime = environment.build.time ? build.time : null;
    readonly homeRoute = computed(() => getHomeRoute(this.userFacade.user()?.role));
}
